import { ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue'
import { useStore } from '@/stores/main'
import shortUUID from 'short-uuid'
import locoScroll from '@/assets/js/lenisScroll'

const scrollY = ref(0)
const scrollX = ref(0)
const scrollProgress = ref(0)

export default function useUtils() {
  const device = ref()
  const observer = ref()

  const genUUID = () => {
    return shortUUID('0123456789ABCDEFGHIJKLMNOQRSTUVWXYZ').generate()
  }

  const decodeTitle = (title) => {
    const txt = document.createElement('textarea')
    txt.innerHTML = title
    return txt.value
  }

  const convertToRelative = (url) => {
    const store = useStore()
    const path = url.replace(store.site.url, '')
    return path
  }

  // const isExternal = (url) => {
  //   const domain = (url) => {
  //     return url.replace('http://', '').replace('https://', '').split('/')[0]
  //   }
  //   return domain(location.href) !== domain(url)
  // }

  const isExternal = (url) => {
    // Treat relative URLs as internal
    if (!url || url.startsWith('/') || url.startsWith('#')) return false

    // If URL doesn't start with http:// or https://, treat as internal
    if (!url.startsWith('http://') && !url.startsWith('https://')) return false

    const domain = (url) => {
      return url.replace(/^https?:\/\//, '').split('/')[0]
    }

    return domain(window.location.href) !== domain(url)
  }

  const isDevice = (val) => {
    if (val < 768) {
      return (device.value = 'mobile')
    } else if (val >= 768 && val < 1165) {
      return (device.value = 'tablet')
    } else if (val >= 1165) {
      return (device.value = 'desktop')
    }
  }

  function equalUrls(url1, url2) {
    const store = useStore()
    // remove trailing slash
    const from = url1.endsWith('/') ? url1.slice(0, -1) : url1
    const to = url2.endsWith('/') ? url2.slice(0, -1) : url2
    return (
      new URL(from, store.site.url).pathname ===
      new URL(to, store.site.url).pathname
    )
  }

  const setScrollProgress = (progress) => {
    scrollProgress.value = progress
  }

  const scrollToHash = (section, offset = 150, delay = 0) => {
    setTimeout(() => {
      locoScroll.scrollTo(`#${section}`, {
        immediate: false,
        duration: 1.2,
        offset: -offset,
      })
    }, delay)
  }

  onBeforeMount(() => {
    observer.value = new ResizeObserver((entries) => {
      for (const entry of entries) {
        device.value = isDevice(entry.contentRect.width)
      }
    })

    observer.value.observe(document.querySelector('body'))
    device.value = isDevice(window.screen.width)
  })

  onMounted(() => {
    const body = document.querySelector('body')
    body.addEventListener('scroll', () => {
      scrollY.value = body.scrollY
      scrollX.value = body.scrollX
    })
  })

  onBeforeUnmount(() =>
    observer.value.unobserve(document.querySelector('body'))
  )

  return {
    device,
    equalUrls,
    scrollY,
    scroll,
    decodeTitle,
    convertToRelative,
    isExternal,
    setScrollProgress,
    genUUID,
    scrollToHash,
  }
}
